module.exports = __webpack_public_path__ + "img/img-business.7b6f4a2f.png";